import { z } from 'zod';

const walletTypes = ['cash', 'bank', 'crypto', 'payment_system'] as const;

const walletTypeSchema = z
  .string({ required_error: 'Please select a wallet type' })
  .min(1, 'Please select a wallet type')
  .refine((val): val is typeof walletTypes[number] => walletTypes.includes(val as any), {
    message: 'Please select a wallet type',
  });

export const createWalletSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  type: walletTypeSchema,
  currencyCode: z.string().min(1, 'Please select a currency'),
  address: z.string().optional(),
  description: z.string().optional(),
});

export const editWalletSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  type: walletTypeSchema,
  currencyCode: z.string().min(1, 'Please select a currency'),
  address: z.string().optional(),
  description: z.string().optional(),
  isActive: z.preprocess((val) => val === 'true' || val === true, z.boolean()),
});

export type CreateWalletFormData = z.infer<typeof createWalletSchema>;
export type EditWalletFormData = z.infer<typeof editWalletSchema>;
